import util from '@/util/util'
import nativeHybrid from '@/util/nativeHybrid'
import qs from 'qs'

export default {
	goToSeller(path = '/carhome') {
		let projectId = '10022'

		if (util.isInWebview()) {
			const params = {
				is_nav_show: false,
				wv: 'lg',
				page_source: 'secondCar'
			}

			nativeHybrid.openURL(
				util.getBaseEnvInfo().sellerUrl + `/module_${projectId}${path}?${qs.stringify(params)}`
			)
		} else {
			window.location.href = util.getBaseEnvInfo().sellerUrl + `/module_${projectId}${path}`
		}
	},

	goToRoute(path, query = {}, isReplace = false) {
		let projectId = '10021'
		const params = nativeHybrid.isCNDo()
			? {
					header: JSON.stringify({ isShow: false }),
					is_nav_show: false,
					wv: 'do',
					...query
			  }
			: {
					is_nav_show: false,
					wv: 'lg',
					...query
			  }

		if (nativeHybrid.isWeapp()) {
			if (!query.access_token) {
				query.access_token = util.getQueryString('access_token')
			}
			const subpath = `${path}?${qs.stringify(query)}`

			window.wx.miniProgram.navigateTo({
				url: `/modules/second-hand/pages/SecondHand?page=${encodeURIComponent(subpath)}`
			})
		} else {
			const href = util.getBaseEnvInfo().openUrl + `/module_${projectId}${path}?${qs.stringify(params)}`;
			console.log('跳转商品详情=>', href)
			nativeHybrid[isReplace ? 'replace' : 'openURL'](href);
		}
	},

	goToIMchat() {
		function openIMchat() {
			console.log(
				'二手车专员聊天窗口link>>>>' +
					`nio://conversation?id=${util.getBaseEnvInfo().secondHandChatPersonId}&type=private`
			)
			nativeHybrid.openURL(
				`nio://conversation?id=${util.getBaseEnvInfo().secondHandChatPersonId}&type=private`
			)
		}

		if (util.isInWebview()) {
			if (!util.isToken()) {
				nativeHybrid.openLoginPage(() => {
					openIMchat()
				})
			} else {
				openIMchat()
			}
		}
	}
}
